import { LearningPath, LearningPathStandard, PathAssignment } from './types';
import { mockStandards } from './mockStandards';

// Mock learning paths for students with different numbers of paths per student
export const studentLearningPaths: LearningPath[] = [
  // Student 001 - 4 Learning Paths
  {
    id: 'student-path-001',
    name: 'Math Foundations',
    description: 'Core math concepts for building strong fundamentals',
    creatorId: 'teacher-001',
    isPreset: false,
    standards: [
      { standardId: 'standard-004', sequenceOrder: 1 }, // 1.OA.A.1 - Use addition and subtraction within 20 to solve word problems
      { standardId: 'standard-005', sequenceOrder: 2 }, // 1.OA.A.2 - Solve word problems with three whole numbers
      { standardId: 'standard-006', sequenceOrder: 3 }, // 2.OA.A.1 - Use addition and subtraction within 100
      { standardId: 'standard-007', sequenceOrder: 4 }, // 2.NBT.A.1 - Understand place value
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-001-1',
        pathId: 'student-path-001',
        assignedBy: 'teacher-001',
        assignedToType: 'Student',
        assignedToId: 'student-001',
        isPriority: true,
        restrictProgression: false,
        startDate: '2025-05-01T09:00:00Z',
        endDate: '2025-07-31T23:59:59Z'
      }
    ],
    createdAt: '2025-05-01T08:30:00Z',
    updatedAt: '2025-05-01T08:30:00Z',
    grade: '2',
  },
  {
    id: 'student-path-002',
    name: 'Advanced Problem Solving',
    description: 'Developing critical thinking through advanced problem solving',
    creatorId: 'teacher-002',
    isPreset: false,
    standards: [
      { standardId: 'standard-006', sequenceOrder: 1 }, // 2.OA.A.1 - Use addition and subtraction within 100 (overlapping)
      { standardId: 'standard-007', sequenceOrder: 2 }, // 2.NBT.A.1 - Understand place value (overlapping)
      { standardId: 'standard-008', sequenceOrder: 3 }, // 3.OA.A.1 - Interpret products of whole numbers
      { standardId: 'standard-009', sequenceOrder: 4 }, // 3.OA.A.2 - Interpret whole-number quotients
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-002-1',
        pathId: 'student-path-002',
        assignedBy: 'teacher-002',
        assignedToType: 'Student',
        assignedToId: 'student-001',
        isPriority: false,
        restrictProgression: true,
        startDate: '2025-05-15T09:00:00Z',
        endDate: '2025-06-05T23:59:59Z' // Today's date for deadline alert
      }
    ],
    createdAt: '2025-05-15T08:30:00Z',
    updatedAt: '2025-05-15T08:30:00Z',
    grade: '3',
  },
  {
    id: 'student-path-003',
    name: 'Geometry Exploration',
    description: 'Exploring shapes, angles, and spatial relationships',
    creatorId: 'teacher-001',
    isPreset: false,
    standards: [
      { standardId: 'standard-010', sequenceOrder: 1 }, // 2.G.A.1 - Recognize and draw shapes
      { standardId: 'standard-011', sequenceOrder: 2 }, // 2.G.A.2 - Partition rectangles
      { standardId: 'standard-012', sequenceOrder: 3 }, // 2.G.A.3 - Partition circles and rectangles
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-003-1',
        pathId: 'student-path-003',
        assignedBy: 'teacher-001',
        assignedToType: 'Student',
        assignedToId: 'student-001',
        isPriority: false,
        restrictProgression: false,
        startDate: '2025-05-20T09:00:00Z',
        endDate: '2025-05-30T23:59:59Z' // Past date for missed deadline alert
      }
    ],
    createdAt: '2025-05-20T08:30:00Z',
    updatedAt: '2025-05-20T08:30:00Z',
    grade: '2',
  },
  {
    id: 'student-path-004',
    name: 'Measurement Mastery',
    description: 'Understanding units of measurement and their applications',
    creatorId: 'teacher-002',
    isPreset: false,
    standards: [
      { standardId: 'standard-013', sequenceOrder: 1 }, // 2.MD.A.1 - Measure length
      { standardId: 'standard-014', sequenceOrder: 2 }, // 2.MD.A.2 - Measure twice with different units
      { standardId: 'standard-015', sequenceOrder: 3 }, // 2.MD.A.3 - Estimate lengths
      { standardId: 'standard-016', sequenceOrder: 4 }, // 2.MD.A.4 - Compare measurements
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-004-1',
        pathId: 'student-path-004',
        assignedBy: 'teacher-002',
        assignedToType: 'Student',
        assignedToId: 'student-001',
        isPriority: false,
        restrictProgression: false,
        startDate: '2025-06-01T09:00:00Z',
        endDate: '2025-09-01T23:59:59Z'
      }
    ],
    createdAt: '2025-06-01T08:30:00Z',
    updatedAt: '2025-06-01T08:30:00Z',
    grade: '2',
  },
  
  // Student 002 - 3 Learning Paths
  {
    id: 'student-path-005',
    name: 'Number Sense Foundations',
    description: 'Building a strong foundation in number sense and operations',
    creatorId: 'teacher-001',
    isPreset: false,
    standards: [
      { standardId: 'standard-004', sequenceOrder: 1 }, // 1.OA.A.1 - Use addition and subtraction within 20
      { standardId: 'standard-005', sequenceOrder: 2 }, // 1.OA.A.2 - Solve word problems
      { standardId: 'standard-017', sequenceOrder: 3 }, // 1.NBT.A.1 - Count to 120
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-005-1',
        pathId: 'student-path-005',
        assignedBy: 'teacher-001',
        assignedToType: 'Student',
        assignedToId: 'student-002',
        isPriority: true,
        restrictProgression: false,
        startDate: '2025-05-01T09:00:00Z',
        endDate: '2025-07-31T23:59:59Z'
      }
    ],
    createdAt: '2025-05-01T08:30:00Z',
    updatedAt: '2025-05-01T08:30:00Z',
    grade: '1',
  },
  {
    id: 'student-path-006',
    name: 'Fraction Fundamentals',
    description: 'Introduction to fractions and their applications',
    creatorId: 'teacher-002',
    isPreset: false,
    standards: [
      { standardId: 'standard-018', sequenceOrder: 1 }, // 3.NF.A.1 - Understand fractions
      { standardId: 'standard-019', sequenceOrder: 2 }, // 3.NF.A.2 - Fractions on number line
      { standardId: 'standard-020', sequenceOrder: 3 }, // 3.NF.A.3 - Equivalent fractions
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-006-1',
        pathId: 'student-path-006',
        assignedBy: 'teacher-002',
        assignedToType: 'Student',
        assignedToId: 'student-002',
        isPriority: false,
        restrictProgression: true,
        startDate: '2025-05-15T09:00:00Z',
        endDate: '2025-08-15T23:59:59Z'
      }
    ],
    createdAt: '2025-05-15T08:30:00Z',
    updatedAt: '2025-05-15T08:30:00Z',
    grade: '3',
  },
  {
    id: 'student-path-007',
    name: 'Data Analysis',
    description: 'Collecting, organizing, and interpreting data',
    creatorId: 'teacher-001',
    isPreset: false,
    standards: [
      { standardId: 'standard-021', sequenceOrder: 1 }, // 2.MD.D.9 - Generate measurement data
      { standardId: 'standard-022', sequenceOrder: 2 }, // 2.MD.D.10 - Draw picture/bar graphs
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-007-1',
        pathId: 'student-path-007',
        assignedBy: 'teacher-001',
        assignedToType: 'Student',
        assignedToId: 'student-002',
        isPriority: false,
        restrictProgression: false,
        startDate: '2025-06-01T09:00:00Z',
        endDate: '2025-09-01T23:59:59Z'
      }
    ],
    createdAt: '2025-06-01T08:30:00Z',
    updatedAt: '2025-06-01T08:30:00Z',
    grade: '2',
  },
  
  // Student 003 - 2 Learning Paths
  {
    id: 'student-path-008',
    name: 'Multiplication Mastery',
    description: 'Developing fluency with multiplication facts and concepts',
    creatorId: 'teacher-002',
    isPreset: false,
    standards: [
      { standardId: 'standard-008', sequenceOrder: 1 }, // 3.OA.A.1 - Interpret products
      { standardId: 'standard-023', sequenceOrder: 2 }, // 3.OA.B.5 - Properties of operations
      { standardId: 'standard-024', sequenceOrder: 3 }, // 3.OA.C.7 - Fluently multiply and divide
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-008-1',
        pathId: 'student-path-008',
        assignedBy: 'teacher-002',
        assignedToType: 'Student',
        assignedToId: 'student-003',
        isPriority: true,
        restrictProgression: false,
        startDate: '2025-05-01T09:00:00Z',
        endDate: '2025-07-31T23:59:59Z'
      }
    ],
    createdAt: '2025-05-01T08:30:00Z',
    updatedAt: '2025-05-01T08:30:00Z',
    grade: '3',
  },
  {
    id: 'student-path-009',
    name: 'Time and Money',
    description: 'Understanding time concepts and money values',
    creatorId: 'teacher-001',
    isPreset: false,
    standards: [
      { standardId: 'standard-025', sequenceOrder: 1 }, // 2.MD.C.7 - Tell and write time
      { standardId: 'standard-026', sequenceOrder: 2 }, // 2.MD.C.8 - Solve word problems with money
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-009-1',
        pathId: 'student-path-009',
        assignedBy: 'teacher-001',
        assignedToType: 'Student',
        assignedToId: 'student-003',
        isPriority: false,
        restrictProgression: false,
        startDate: '2025-05-15T09:00:00Z',
        endDate: '2025-08-15T23:59:59Z'
      }
    ],
    createdAt: '2025-05-15T08:30:00Z',
    updatedAt: '2025-05-15T08:30:00Z',
    grade: '2',
  },
  
  // Student 004 - 1 Learning Path
  {
    id: 'student-path-010',
    name: 'Comprehensive Math Review',
    description: 'A complete review of grade-level math concepts',
    creatorId: 'teacher-002',
    isPreset: false,
    standards: [
      { standardId: 'standard-004', sequenceOrder: 1 }, // 1.OA.A.1 - Use addition and subtraction within 20
      { standardId: 'standard-006', sequenceOrder: 2 }, // 2.OA.A.1 - Use addition and subtraction within 100
      { standardId: 'standard-008', sequenceOrder: 3 }, // 3.OA.A.1 - Interpret products
      { standardId: 'standard-018', sequenceOrder: 4 }, // 3.NF.A.1 - Understand fractions
      { standardId: 'standard-025', sequenceOrder: 5 }, // 2.MD.C.7 - Tell and write time
    ],
    assignedTo: [
      {
        id: 'assignment-student-path-010-1',
        pathId: 'student-path-010',
        assignedBy: 'teacher-002',
        assignedToType: 'Student',
        assignedToId: 'student-004',
        isPriority: true,
        restrictProgression: false,
        startDate: '2025-05-01T09:00:00Z',
        endDate: '2025-08-31T23:59:59Z'
      }
    ],
    createdAt: '2025-05-01T08:30:00Z',
    updatedAt: '2025-05-01T08:30:00Z',
    grade: '3',
  }
];

// Create a mapping of standards to their details for easy access
export const standardDetailsMap = mockStandards.reduce((map, standard) => {
  map[standard.id] = standard;
  return map;
}, {} as Record<string, typeof mockStandards[0]>);
